import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { reverse } from 'ramda';
import { PlayerResource } from '~~apis/resource';
import TeamHeader from './TeamHeader';
import TeamSeasonHeader from './TeamSeasonHeader';
import PlayerDisplay from '../../Tournament/TournamentTeam/PlayerDisplay';
import { StyledPlayer } from '../../Tournament/styled';

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  letter-spacing: 1px;
  padding-top: 2rem;

  .divider {
    border: 1px #222 solid;
    width: 100%;
    height: 0px;
  }
`;

const TeamSeasonProfile = ({ teams, reload }) => {
  const [teamIndex, setTeamIndex] = useState(0);

  const [seasons, setSeasons] = useState([]);
  const [seasonIndex, setSeasonIndex] = useState(-1);
  // 部分球隊單一賽季可能有兩支隊伍
  const [seasonTeamIndex, setSeasonTeamIndex] = useState(-1);

  const [seasonTeamPlayers, setSeasonTeamPlayers] = useState([]);
  const [playersCanBeClaimed, setPlayersCanBeClaimed] = useState({});

  useEffect(() => {
    const experienceSeasons = {};
    teams[teamIndex].info.experiences.forEach((experience) => {
      if (!experienceSeasons[experience.season_uniqid]) {
        experienceSeasons[experience.season_uniqid] = {
          seasonName: experience.season,
          uniqid: experience.season_uniqid,
          year: experience.season_year,
          teams: [],
        };
      }

      experienceSeasons[experience.season_uniqid].teams.push({
        name: experience.team,
        uniqid: experience.season_team_uniqid,
      });
    });

    setSeasons(reverse(Object.values(experienceSeasons)));
  }, [teamIndex, teams]);

  useEffect(() => {
    setSeasonTeamPlayers([]);
    if (!seasons[seasonIndex] || !seasons[seasonIndex].teams[seasonTeamIndex]) {
      return;
    }

    PlayerResource.getPlayersInSeasonTeam({
      seasonUniqid: seasons[seasonIndex].uniqid,
      seasonTeamUniqid: seasons[seasonIndex].teams[seasonTeamIndex].uniqid,
    })
      .then(({ data }) => {
        setSeasonTeamPlayers(data);
        PlayerResource.getPlayersClaimStatus({
          playerUniqids: data.map((p) => p.uniqid),
        })
          .then(({ data: claimStatus }) => {
            const canBeClaimed = {};
            Object.keys(claimStatus).forEach((uniqid) => {
              canBeClaimed[uniqid] = !claimStatus[uniqid].adopted;
              return;
            });
            setPlayersCanBeClaimed(canBeClaimed);
          })
          .catch(() => {});
      })
      .catch(() => {});
  }, [seasonIndex, seasonTeamIndex, seasons, teams]);

  const claimedCallback = (playerUniqid) => {
    setPlayersCanBeClaimed({
      ...playersCanBeClaimed,
      [playerUniqid]: false,
    });

    PlayerResource.getPlayersClaimStatus({
      playerUniqids: seasonTeamPlayers.map((p) => p.uniqid),
    })
      .then(({ data: claimStatus }) => {
        const canBeClaimed = {};
        Object.keys(claimStatus).forEach((uniqid) => {
          canBeClaimed[uniqid] = !claimStatus[uniqid].adopted;
          return;
        });
        setPlayersCanBeClaimed(canBeClaimed);
      })
      .catch(() => {});
  };

  return (
    <StyledDiv>
      {teams.length > 0 && <TeamHeader teams={teams} teamIndex={teamIndex} setTeamIndex={setTeamIndex} />}
      {seasons.length === 0 && <>尚未參與任何賽事</>}
      {seasons.length > 0 && (
        <>
          <TeamSeasonHeader
            seasons={seasons}
            seasonIndex={seasonIndex}
            seasonTeamIndex={seasonTeamIndex}
            setSeasonIndex={setSeasonIndex}
            setSeasonTeamIndex={setSeasonTeamIndex}
          />
          <hr className="divider" />
          <StyledPlayer>
            <div className="registration--header">登錄球員</div>
            <div className="registration--list">
              {seasonTeamPlayers.map((player, index) => (
                <div className="registration--item" key={index}>
                  <PlayerDisplay
                    editable={false}
                    player={player}
                    handlePlayerEdit={() => {}}
                    handlePlayerDelete={() => {}}
                    canBeClaimed={!!playersCanBeClaimed[player.uniqid]}
                    claimedCallback={claimedCallback}
                  />
                </div>
              ))}
            </div>
          </StyledPlayer>
        </>
      )}
    </StyledDiv>
  );
};

export default TeamSeasonProfile;
